module.exports = __webpack_public_path__ + "img/logo.8bf486d8.png";